import { Row, Typography } from 'antd';
import { CSSProperties } from 'react';
import { appVersion } from '../environment';

const { Link, Text } = Typography;

export const AppFooter: React.FC = () => {
    return (
        <Row justify='center'>
            <Link target='blank' href={`https://maas-insurance.de/impressum`} style={linkStyle}>
                {'Impressum'}
            </Link>
            <Text style={textStyle}>{'|'}</Text>
            <Link
                target='blank'
                href={`https://maas-insurance.de/datenschutzerklarung`}
                style={linkStyle}
            >
                {'Datenschutzerklärung'}
            </Link>
            <Text style={textStyle}>{'|'}</Text>
            <Text style={textStyle}>{'Version ' + appVersion}</Text>
        </Row>
    );
};

const textStyle: CSSProperties = {
    color: 'white',
    margin: '0 6px',
};

const linkStyle: CSSProperties = {
    ...textStyle,
    textDecoration: 'underline',
};